// off-canvas open and close
document.querySelectorAll('[data-nav-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    document.body.classList.toggle('nav-is-open');
  });
});

document.querySelectorAll('.has-child-link').forEach((link) => {
  link.addEventListener('click', (e) => {
    e.preventDefault();

    //regardless of where we are and what happens, toggle the submenu
    e.target.classList.toggle('open-subs');
    e.target.parentNode.classList.toggle('down');
  });
});
